import {
  ACTION_ITEMS_LIST_REDUCER_ADD,
  ACTION_ITEMS_LIST_REDUCER_REMOVE,
  ACTION_ITEMS_LIST_REDUCER_REMOVE_ALL,
  ACTION_ITEMS_LIST_REDUCER_UPDATE,
  ACTION_ITEM_DISABLE_EDITING,
  ACTION_ITEM_ENABLE_EDITING,
  ACTION_ITEM_UPDATE,
} from 'actions/actionItem';

function findActionItemIndex({ actionItems = [], id, key }) {
  const returnIndex = actionItems.findIndex((actionItem) => actionItem.uuid === id);
  return returnIndex >= 0 ? returnIndex : actionItems.findIndex((actionItem) => actionItem.uiKey === key);
}

export function ActionItemReducer(state, action) {
  switch (action.type) {
    case ACTION_ITEM_UPDATE: {
      return { ...state, ...action.data.actionItem };
    }
    case ACTION_ITEM_ENABLE_EDITING: {
      return { ...state, isEditing: true };
    }
    case ACTION_ITEM_DISABLE_EDITING: {
      const task = action.data.task || {};
      return { ...state, ...task, isEditing: false };
    }
    default:
      return state;
  }
}

export default function ActionItemListReducer(state = [], action) {
  switch (action.type) {
    case ACTION_ITEMS_LIST_REDUCER_ADD: {
      return action.addType === 'append' ? [...state, ...action.actionItems] : [...action.actionItems, ...state];
    }
    case ACTION_ITEMS_LIST_REDUCER_UPDATE: {
      return [...action.actionItems];
    }

    case ACTION_ITEMS_LIST_REDUCER_REMOVE_ALL: {
      return [];
    }
    case ACTION_ITEMS_LIST_REDUCER_REMOVE: {
      const { actionItemId, uiKey } = action.data;
      // either a actionItemId or key should be present to find the actionItem in the array
      if (!actionItemId && !uiKey) return state;
      if (actionItemId) return state.filter((actionItem) => actionItem.uuid !== actionItemId);
      return state.filter((actionItem) => actionItem.uiKey !== uiKey);
    }

    default: {
      const actionItemIndex = findActionItemIndex({
        actionItems: state,
        id: action.data?.uuid,
        key: action.data?.uiKey,
      });

      const actionItem = state[actionItemIndex];

      if (actionItem) {
        const newActionItem = ActionItemReducer(actionItem, action);
        const newState = [...state];

        newState[actionItemIndex] = newActionItem;
        return newState;
      }

      return state;
    }
  }
}
